import React, { PropTypes } from 'react'
import ReactDOM from 'react-dom'
import Link from 'gatsby-link'

export default class Menu extends React.Component {
  constructor(props) {
    super(props);

    this.toggleClassName = (container, menu) => {
      container.classList.toggle('-open');
      menu.childNodes[0].classList.toggle('-close');
    };
  }
  
  componentDidMount () {
    this.menuContainer = ReactDOM.findDOMNode(this.refs.menuContainer);
    this.menu = ReactDOM.findDOMNode(this.refs.menu);

    this.menu.addEventListener('click', this.toggleClassName.bind(null, this.menuContainer, this.menu));
  }

  componentWillUnmount() {
    this.menu.removeEventListener('click', this.toggleClassName);
  }

  render() {
    const { color } = this.props;
    return (
      <div
        className="panel-button-container"
        ref="menuContainer"
      >
        <span
          id="menu"
          className="panel-button"
          ref="menu"
        >
          <span
            className={`panel-button-icon ${color}`}
          />
        </span>
        <ul>
          <li><Link to="/" className="">トップページ</Link></li>
          <li><Link to="/kitchen" className="">キッチン</Link></li>
          <li><Link to="/coworkingspace" className="">コワーキングスペース</Link></li>
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu.js